import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {userTrainingPageText as userTrainingPageText_en} from "../libs/en/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_en_ca} from "../libs/en-ca/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_de} from "../libs/de/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_de_ch} from "../libs/de-ch/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fr} from "../libs/fr/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fr_fr} from "../libs/fr-fr/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fr_ca} from "../libs/fr-ca/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_nl} from "../libs/nl/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_it} from "../libs/it/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_it_ch} from "../libs/it-ch/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_cz} from "../libs/cz/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fi} from "../libs/fi/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_pl} from "../libs/pl/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_se} from "../libs/se/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_no} from "../libs/no/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_dk} from "../libs/dk/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_es} from "../libs/es/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_pt} from "../libs/pt/texts-user-training-page-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';
import {Link} from "react-router-dom";
import {GOOGLE_PLAY_APP_URL, APPLE_APP_STORE_URL} from "../utils/appStoreLinks";
import {AdditionalResourcesSection} from './AdditionalResourcesSection';

export class UserTraining extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            userTrainingPageText: userTrainingPageText_en,
            prefix: '',
            isVideoPlaying: false,
            showVideo: true  // Changed to true for autoplay
        };
        this.videoRef = React.createRef();
        this.handleVideoPlay = this.handleVideoPlay.bind(this);
        this.handleVideoPause = this.handleVideoPause.bind(this);
        this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
        this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
        if (this.state.language === "DE") {
            this.state.userTrainingPageText = userTrainingPageText_de;
            this.state.prefix = '/de';
        }
        if (this.state.language === "DE-CH") {
            this.state.userTrainingPageText = userTrainingPageText_de_ch;
            this.state.prefix = '/de-ch';
        }
        if (this.state.language === "EN-CA") {
            this.state.userTrainingPageText = userTrainingPageText_en_ca;
            this.state.prefix = '/en-ca';
        }
        if (this.state.language === "FR-FR") {
            this.state.userTrainingPageText = userTrainingPageText_fr_fr;
            this.state.prefix = '/fr';
        }
        if (this.state.language === "FR") {
            this.state.userTrainingPageText = userTrainingPageText_fr;
            this.state.prefix = '/fr-ch';
        }
        if (this.state.language === "FR-CA") {
            this.state.userTrainingPageText = userTrainingPageText_fr_ca;
            this.state.prefix = '/fr-ca';
        }
        if (this.state.language === "NL") {
            this.state.userTrainingPageText = userTrainingPageText_nl;
            this.state.prefix = '/nl';
        }
        if (this.state.language === "IT") {
            this.state.userTrainingPageText = userTrainingPageText_it;
            this.state.prefix = '/it';
        }
        if (this.state.language === "IT-CH") {
            this.state.userTrainingPageText = userTrainingPageText_it_ch;
            this.state.prefix = '/it-ch';
        }
        if (this.state.language === "CZ") {
            this.state.userTrainingPageText = userTrainingPageText_cz;
            this.state.prefix = '/cz';
        }
        if (this.state.language === "FI") {
            this.state.userTrainingPageText = userTrainingPageText_fi;
            this.state.prefix = '/fi';
        }
        if (this.state.language === "PL") {
            this.state.userTrainingPageText = userTrainingPageText_pl;
            this.state.prefix = '/pl';
        }
        if (this.state.language === "SE") {
            this.state.userTrainingPageText = userTrainingPageText_se;
            this.state.prefix = '/se';
        }
        if (this.state.language === "NO") {
            this.state.userTrainingPageText = userTrainingPageText_no;
            this.state.prefix = '/nb';
        }
        if (this.state.language === "DK") {
            this.state.userTrainingPageText = userTrainingPageText_dk;
            this.state.prefix = '/dk';
        }
        if (this.state.language === "ES") {
            this.state.userTrainingPageText = userTrainingPageText_es;
            this.state.prefix = '/es';
        }
        if (this.state.language === "PT") {
            this.state.userTrainingPageText = userTrainingPageText_pt;
            this.state.prefix = '/pt';
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_en,
                    prefix: ''
                });
            }
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_de,
                    prefix: '/de'
                });
            }
            if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_de_ch,
                    prefix: '/de-ch'
                });
            }
            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_en_ca,
                    prefix: '/en-ca'
                });
            }
            if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_fr,
                    prefix: '/fr-ch'
                });
            }
            if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_fr_ca,
                    prefix: '/fr-ca'
                });
            }
            if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_fr_fr,
                    prefix: '/fr'
                });
            }
            if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_nl,
                    prefix: '/nl'
                });
            }
            if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_it,
                    prefix: '/it'
                });
            }
            if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_it_ch,
                    prefix: '/it-ch'
                });
            }
            if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_cz,
                    prefix: '/cz'
                });
            }
            if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_fi,
                    prefix: '/fi'
                });
            }
            if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_pl,
                    prefix: '/pl'
                });
            }
            if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_se,
                    prefix: '/se'
                });
            }
            if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_no,
                    prefix: '/nb'
                });
            }
            if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_dk,
                    prefix: '/dk'
                });
            }
            if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_es,
                    prefix: '/es'
                });
            }
            if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    userTrainingPageText: userTrainingPageText_pt,
                    prefix: '/pt'
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        // Autoplay video when component mounts
        if (this.videoRef.current) {
            this.videoRef.current.play().catch(error => {
                console.log('Autoplay was prevented:', error);
                // Autoplay might be blocked by browser, that's okay
            });
        }
    }

    handlePlayButtonClick() {
        this.setState({ showVideo: true, isVideoPlaying: true }, () => {
            if (this.videoRef.current) {
                this.videoRef.current.play();
            }
        });
    }

    handleVideoPlay() {
        this.setState({ isVideoPlaying: true });
    }

    handleVideoPause() {
        this.setState({ isVideoPlaying: false });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.userTrainingPageText.title)}</title>
                    <meta name="title" content={parse(this.state.userTrainingPageText.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.userTrainingPageText.descriptionMeta)}/>
                    <meta property="og:locale" content={this.state.userTrainingPageText.localeMeta}/>
                    <meta name="keywords" content={this.state.userTrainingPageText.keywords}/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner user-training-page">
                    <div className="container">
                        <div className="justify-content-center">
                            <div className="user-training-header">
                                <h1 style={{
                                    color: '#04ABA0',
                                    fontSize: '40px',
                                    fontWeight: '700',
                                    textAlign: 'center',
                                    marginBottom: '8px'
                                }}>{parse(this.state.userTrainingPageText.mainHeader)}</h1>
                                <p style={{
                                    color: '#3C3C3C',
                                    fontSize: '32px',
                                    fontWeight: '300',
                                    textAlign: 'center',
                                    marginBottom: '20px',
                                    width: '100%',
                                    maxWidth: '1049px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}>{parse(this.state.userTrainingPageText.mainSubHeader)}</p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started Section */}
                <section className="getting-started-section" style={{
                    background: 'linear-gradient(180deg, rgba(37, 139, 204, 1) 0%, rgba(4, 171, 160, 1) 100%)',
                    padding: '75px 0px 80px',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-12 col-lg-6">
                                <h2 style={{
                                    fontSize: '32px',
                                    fontWeight: '300',
                                    color: '#FFFFFF',
                                    marginBottom: '27px',
                                    fontFamily: 'Roboto'
                                }}>{parse(this.state.userTrainingPageText.gettingStartedHeader)}</h2>
                                
                                {/* Step 1 */}
                                <div style={{ marginBottom: '40px' , marginTop: '-10px'}}>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '16px',
                                        lineHeight:'1.5'
                                    }}>{parse(this.state.userTrainingPageText.step1Title)}</h3>
                                    <div className="logo-container" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                    <a href={GOOGLE_PLAY_APP_URL}
                                           target="_blank" 
                                           rel="noopener noreferrer">
                                            <img src="/images/google-play-badge.png" 
                                                 alt="Get it on Google Play" 
                                                 loading="lazy"
                                                 decoding="async"
                                                 style={{ height: '72px', width: 'auto' }} />
                                        </a>
                                        <a href={APPLE_APP_STORE_URL}
                                           target="_blank" 
                                           rel="noopener noreferrer">
                                            <img src="/images/app-store.png" 
                                                 alt="Download on App Store" 
                                                 loading="lazy"
                                                 decoding="async"
                                                 style={{ height: '72px', width: 'auto' }} />
                                        </a>
                                       
                                    </div>
                                </div>

                                {/* Step 2 */}
                                <div style={{ marginBottom: '40px' }}>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '8px',
                                        lineHeight:'1.5'
                                    }}>{parse(this.state.userTrainingPageText.step2Title)}</h3>
                                </div>

                                {/* Step 3 */}

                                <div style={{ marginBottom: '40px' }}>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '8px',
                                        lineHeight:'1.5'
                                    }}>{parse(this.state.userTrainingPageText.step3Title)}</h3>
                                </div>

                                {/* Step 4 */}
                                <div className='step-4-container'>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '8px',
                                        lineHeight:'1.5'
                                    }}>
                                        <span>{parse(this.state.userTrainingPageText.step4Title)}</span>
                                        <span className='tooltip-container' style={{ position: 'relative', top: '-2px', display: 'inline-block', marginLeft: '7px' }}>
                                            <img 
                                                src="/images/info-circle.svg" 
                                                alt="Info" 
                                                loading="lazy"
                                                decoding="async"
                                                style={{ width: '22px', height: '22px', cursor: 'pointer', verticalAlign: 'middle' }}
                                                onMouseOver={e => {
                                                    const tooltip = e.currentTarget.nextSibling;
                                                    if (tooltip) tooltip.style.display = 'block';
                                                }}
                                                onMouseOut={e => {
                                                    const tooltip = e.currentTarget.nextSibling;
                                                    if (tooltip) tooltip.style.display = 'none';
                                                }}
                                            />
                                            <span 
                                                style={{
                                                    display: 'none',
                                                    position: 'absolute',
                                                    left: '110%',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#fff',
                                                    color: '#000',
                                                    padding: '22px 20px',
                                                    borderTopRightRadius: '12px',
                                                    borderBottomRightRadius: '12px',
                                                    borderBottomLeftRadius: '12px',
                                                    fontSize: '20px',
                                                    fontFamily:'Roboto',
                                                    zIndex: 100,
                                                    fontWeight: '300',
                                                    lineHeight: '1.171875',
                                                    width: '330px',
                                                    whiteSpace: 'normal'
                                                }}
                                            >
                                               Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.
                                            </span>
                                        </span>
                                    </h3>
                                </div>
                            </div>

                            {/* Phone Mockup with Embedded Video */}
                            <div className="col-12 col-lg-6 phone-mockup-container">
                                <div className="phone-mockup-wrapper">
                                    <img src="/images/phone-mockup-61359e.png" 
                                         alt="CamAPS FX App" 
                                         decoding="async"
                                         className="phone-mockup-image" />
                                    
                                    {/* Video Embedded in Phone Screen - Autoplay */}
                                    <div className="phone-mockup-video-container">
                                        <video
                                            ref={this.videoRef}
                                            controls={false}
                                            className="phone-mockup-video"
                                            onPlay={this.handleVideoPlay}
                                            onPause={this.handleVideoPause}
                                            onEnded={this.handleVideoPause}
                                            playsInline
                                            autoPlay
                                            muted
                                            loop
                                        >
                                            <source src={this.state.userTrainingPageText.videoSrc} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                    {/* Support Section */}
                    <section className="support-section" style={{
                    backgroundColor: '#F9F8F8',
                    padding: '26px 0'
                }}>
                    <div className="container">
                        <div className="row align-items-center justify-content-between" style={{ gap: '23px' }}>
                            {/* Help Icon */}
                            <div className="col-12 col-lg-auto d-flex justify-content-center justify-content-lg-start">
                                <img 
                                    src="/images/help-icon.svg" 
                                    alt="Help" 
                                    loading="lazy"
                                    decoding="async"
                                    style={{ width: '89px', height: '96px' }}
                                />
                            </div>

                            {/* Text Content */}
                            <div className="col-12 col-lg">
                                <h3 style={{
                                    fontSize: '32px',
                                    fontWeight: '300',
                                    color: '#04ABA0',
                                    marginBottom: '8px',
                                    lineHeight: '1.171875'
                                }}>
                                    {parse(this.state.userTrainingPageText.supportSectionTitle)}
                                </h3>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: '400',
                                    color: '#282828',
                                    margin: '0',
                                    lineHeight: '1.171875'
                                }}>
                                    {parse(this.state.userTrainingPageText.supportSectionText)}
                                </p>
                            </div>

                            {/* Support Button */}
                            <div className="col-12 col-lg-auto d-flex justify-content-center justify-content-lg-end">
                                <Link 
                                    to={this.state.prefix + "/support"}
                                    style={{
                                        display: 'inline-block',
                                        backgroundColor: '#04ABA0',
                                        color: '#FFFFFF',
                                        padding: '14px 10px',
                                        borderRadius: '44px',
                                        textDecoration: 'none',
                                        fontSize: '24px',
                                        fontWeight: '600',
                                        lineHeight: '26px',
                                        letterSpacing: '0.7px',
                                        boxShadow: '0px 4px 9px 0px rgba(4, 171, 160, 0.7)',
                                        transition: 'all 0.3s ease',
                                        textAlign: 'center',
                                        minWidth: '313px'
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = '#00baff';
                                        e.currentTarget.style.boxShadow = '0px 6px 12px 0px #00baff';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor ="#04ABA0";
                                        e.currentTarget.style.boxShadow = '0px 4px 9px 0px rgba(4, 171, 160, 0.7)';
                                    }}
                                >
                                    {parse(this.state.userTrainingPageText.supportButtonText)}
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Additional Resources Section */}
                <AdditionalResourcesSection
                    language={this.state.language}
                    prefix={this.state.prefix}
                    userTrainingPageText={this.state.userTrainingPageText}
                />

            
                
                <Footer props={this.props}/>
            </div>
        );
    }
}

